module.exports = __webpack_public_path__ + "static/media/c1.cc78b348.jpg";